module.exports = __webpack_public_path__ + "img/flags.6fe47c22.png";